import React from 'react';

interface IProps {
  className?: string;
}

const TicketIcon = ({ className = '' }: IProps) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      id="ki-ticket"
      fill="#fff"
    >
      <path d="M18 2v1a2 2 0 0 1-4 0V2H9v28h5v-1a2 2 0 0 1 4 0v1h5V2h-5zm-5.87 2a4 4 0 0 0 7.74 0H21v8H11V4h1.13zm7.74 24a4 4 0 0 0-7.74 0H11V14h10v14h-1.13z" />
      <path d="M16.83 18.9l2.59.05-2.06 1.56.75 2.48-2.13-1.47L13.86 23l.75-2.48-2.07-1.56 2.59-.06.84-2.44z" />
    </svg>
  );
};

export default TicketIcon;
